module.exports = __webpack_public_path__ + "static/img/static-zoom-in3.e66a775.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static-zoom-in3.png
// module id = 77
// module chunks = 0